import { render } from "./otpLogin.vue?vue&type=template&id=1689de42&scoped=true"
import script from "./otpLogin.vue?vue&type=script&lang=js"
export * from "./otpLogin.vue?vue&type=script&lang=js"

import "./otpLogin.vue?vue&type=style&index=0&id=1689de42&lang=css"
import "./otpLogin.vue?vue&type=style&index=1&id=1689de42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1689de42"]])

export default __exports__